angular.module('picmonicng').directive('facebookButton', [
  function () {
    return {
      restrict: 'E',
      link: function (scope, element, attrs) {
        element.on('click', function () {
          send_ga('event', 'Referral', 'FB Button Clicked');

          var text =
            "I'm studying with Picmonic, and you should, too. Check out Picmonic Free and get 20% off with this link:";

          FB.ui(
            {
              method: 'share',
              display: 'popup',
              href: attrs.url,
              quote: attrs.text ? attrs.text : text,
            },
            function (response) {}
          );
        });
      },
    };
  },
]);
